<template>
  <b-container fluid>
    <b-row id="recipe-header" class="justify-content-center">
      <b-col md="10">
        <b-row align-h="between">
          <b-col md="6">
            <a href="/">
              <img alt="gravity logo" src="../../assets/logo.png" />
            </a>
          </b-col>
          <b-col md="6" xs="3" class="started-button d-none d-sm-block">
            <b-button
                class="button-white-transparent"
                @click.prevent="scrollFix('#filters')"
            >
              Request Demo
            </b-button>
          </b-col>
        </b-row>
        <b-row align-h="start" class="text-content">
          <b-col>
            <h1 class="text-white title text-left">Clean your dirty CRM</h1>
          </b-col>
        </b-row>
        <b-row align-h="start">
          <b-col class="mt-2">
            <h4 class="text-white text-left" md="6">
              <b>Your CRM loses 5% of its accuracy each month. 	Let's fix that.</b>
            </h4>

          </b-col>
        </b-row>


        <b-row align-h="start">
          <b-col
            cols="12"
            md="6"
            class="d-flex mt-5 justify-content-center justify-content-md-start"
          >
            <b-button
                class="button-white-transparent"
                @click.prevent="scrollFix('#filters')"
            >
              Request Demo
            </b-button>

          </b-col>
        </b-row>

      </b-col>
    </b-row>

  </b-container>
</template>

<style scoped lang="sass">
@import @/sass/screens/home/header.sass
</style>

<script>

import VueScrollTo from 'vue-scrollto';

export default {
  name: 'Header',
  methods: {
    scrollFix: function(hash) {
      console.log('Scroll To')
      VueScrollTo.scrollTo(hash, 3000)
    },

  },
}
</script>
